export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref4702.cd606b23.jpg";